import {
  SkapaPrefixService
} from "@ingka/webc-tools";
import { registerIcon } from "./registerIcon.js";
class CustomPrefixRegistry {
  constructor(tagPrefix = "skapa") {
    /** This function expects a Skapa CustomElement class reference and registers a masked version of it using the previously set prefix and the tagname defined on the class's `skapaTagName` static field
     * The function will also register the dependencies of the element if they are defined in the `skapaDependencies` static field.
     */
    this.assignPrefixService = (elementConstructor) => {
      const tagName = `${this.prefixService.prefix}-${elementConstructor.skapaTagName}`;
      if (this.registeredElements.has(tagName)) {
        return;
      }
      const windowRegisteredElement = customElements.get(tagName);
      if (windowRegisteredElement) {
        if (windowRegisteredElement === elementConstructor || Object.getPrototypeOf(windowRegisteredElement) === elementConstructor) {
        } else {
          console.warn(
            "Custom element (seemingly different version) already defined in a different custom registry with the same prefix: ",
            tagName
          );
        }
        return;
      }
      class MaskedElementConstructor extends elementConstructor {
      }
      elementConstructor.skapaIconDependencies.forEach((icon) => {
        registerIcon(icon);
      });
      elementConstructor.skapaDependencies.forEach(this.assignPrefixService);
      MaskedElementConstructor.prefixService = this.prefixService;
      customElements.define(tagName, MaskedElementConstructor);
      this.registeredElements.set(tagName, MaskedElementConstructor);
    };
    this.registeredElements = /* @__PURE__ */ new Map();
    this.prefixService = new SkapaPrefixService(tagPrefix);
  }
}
export {
  CustomPrefixRegistry
};
